module.exports = __webpack_public_path__ + "static/media/iphone6-2up-grid.ad0a1ea1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/smartphone/iphone6/iphone6-2up-grid.pdf
// module id = 36
// module chunks = 0